import React, { useState, useMemo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { ConfirmationModal } from '@mic3/platform-ui';

import { deleteChatMessage } from 'store/actions/chat/chatActions';

export const useDeleteMessageConfirmation = ({ rid, isAuthor, isRoomOwner }) => {
    const dispatch = useDispatch();
    const [pendingDelete, setPendingDelete] = useState(null);

    const canDelete = isAuthor || isRoomOwner;

    const requestDelete = useCallback(msg => setPendingDelete(msg), []);
    const cancelDelete = useCallback(() => setPendingDelete(null), []);
    const confirmDelete = useCallback(() => {
        if (pendingDelete) {
            dispatch(deleteChatMessage({ rid: pendingDelete.rid || rid, _id: pendingDelete.id || pendingDelete._id }));
        }
        setPendingDelete(null);
    }, [pendingDelete, dispatch, rid]);

    const deleteDialog = useMemo(
        () =>
            pendingDelete ? (
                <ConfirmationModal
                    header="Delete message"
                    message="Are you sure you want to delete this message? This action cannot be undone."
                    open={Boolean(pendingDelete)}
                    onClose={cancelDelete}
                    onConfirm={confirmDelete}
                    confirmButtonText="Delete"
                    declineButtonText="Cancel"
                />
            ) : null,
        [pendingDelete, cancelDelete, confirmDelete]
    );

    return { canDelete, requestDelete, deleteDialog };
};
